/**
 * Inline SVG placeholders — avoids external services like via.placeholder.com.
 */
export function placeholderImage(width, height, label = '') {
  const w = Number(width) || 40;
  const h = Number(height) || w;
  const safeLabel = String(label).replace(/[<>&'"]/g, '').slice(0, 24);
  const fontSize = Math.max(8, Math.min(Math.floor(Math.min(w, h) * 0.32), 24));
  const svg = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">`,
    `<rect width="${w}" height="${h}" fill="#e5e7eb"/>`,
    safeLabel
      ? `<text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#6b7280" font-family="system-ui,sans-serif" font-size="${fontSize}">${safeLabel}</text>`
      : `<circle cx="${w / 2}" cy="${h * 0.38}" r="${Math.floor(Math.min(w, h) * 0.18)}" fill="#9ca3af"/><ellipse cx="${w / 2}" cy="${h * 0.82}" rx="${w * 0.28}" ry="${h * 0.16}" fill="#9ca3af"/>`,
    '</svg>',
  ].join('');
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

/** Short label placeholder for category tiles (e.g. "Engine" → "EN"). */
export function categoryPlaceholder(label, size = 80) {
  const text = String(label || 'Part')
    .replace(/[^a-zA-Z0-9]/g, '')
    .substring(0, 2)
    .toUpperCase() || 'PT';
  return placeholderImage(size, size, text);
}

/** Safe img onError — uses inline SVG once and stops retry loops. */
export function onImgErrorToPlaceholder(event, width, height, label = '') {
  const img = event?.currentTarget || event?.target;
  if (!img || img.dataset.placeholderFallback === '1') return;
  img.dataset.placeholderFallback = '1';
  img.onerror = null;
  img.src = placeholderImage(width, height, label);
}

/** Default profile avatar when user.avatar is missing */
export const AVATAR_PLACEHOLDER = placeholderImage(40, 40);

export const PRODUCT_PLACEHOLDER = placeholderImage(200, 200, 'Part');
export const PRODUCT_PLACEHOLDER_SM = placeholderImage(80, 80, 'Part');
